import apiClient from '../../index';

export const getParent = async (parentId) => {
  if (!parentId) return null;

  try {
    const response = await apiClient.get(`/api/parent/${parentId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching parent:', error);
    throw error;
  }
};

export const parentLogin = async (body) => {
  try {
    const response = await apiClient.post(`/api/parent/login`, body);
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      console.error('Login request timed out. Server might be unavailable.');
      throw new Error(
        'Login request timed out. Please try again or contact support if the issue persists.'
      );
    }
    console.error(`Error on parent login:`, error);
    throw error;
  }
};

export const parentForgotPassword = async (body) => {
  try {
    const response = await apiClient.post(`/api/parent/forgotpassword`, body);
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      console.error('Password request timed out. Server might be unavailable.');
      throw new Error(
        'Password request timed out. Please try again or contact support if the issue persists.'
      );
    }
    console.error(`Error on parent password reset:`, error);
    throw error;
  }
};

export const getParentChildren = async (parentId) => {
  if (!parentId) return [];

  try {
    const response = await apiClient.get(`/api/parent/child/${parentId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching children:', error);
    throw error;
  }
};

export const parentResetPassword = async ({ token, newPassword }) => {
  try {
    const response = await apiClient.post(
      `/api/parent/resetpassword/${token}`,
      {
        newPassword,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      console.error(
        'Password reset request timed out. Server might be unavailable.'
      );
      throw new Error(
        'Password reset request timed out. Please try again or contact support if the issue persists.'
      );
    }
    console.error(`Error on password reset:`, error);
    throw error;
  }
};

export const parentLogout = async () => {
  try {
    const response = await apiClient.post(`/api/parent/logout`);
    return response.data;
  } catch (error) {
    console.error(`Error on parent logout`, error);
    throw error;
  }
};

export const setCurrentChild = (child) => {
  try {
    localStorage.setItem('current_child', JSON.stringify(child));
  } catch (error) {
    console.error(`Error on setting current child`, error);
    throw error;
  }
};

export const getCurrentChild = () => {
  try {
    const value = localStorage.getItem('current_child');
    if (!value) return null;
    return JSON.parse(value);
  } catch (error) {
    console.error('Error on getting current child', error);
    throw error;
  }
};

export const clearCurrentChild = () => {
  try {
    localStorage.removeItem('current_child');
  } catch (error) {
    console.error('Error on removing current child', error);
    throw error;
  }
};
